/* eslint-disable */
import React, { useCallback, useRef } from 'react';
import './index.less';

export interface IWhySmeTargetReasonItem {
  desc?: string;
  title?: string;
}

export interface IWhySmeTargetReasonsProps {
  title?: string;
  description?: string;
  items?: IWhySmeTargetReasonItem[];
  id?: string;
  className?: string;
  onComplete?: () => void;
}

const WhySmeTargetReasons = React.forwardRef<
  HTMLDivElement,
  IWhySmeTargetReasonsProps
>(({ title, description, items = [], id, className, onComplete }, ref) => {
  const completedRef = useRef(false);

  const markComplete = useCallback(() => {
    if (completedRef.current) return;
    completedRef.current = true;
    onComplete?.();
  }, [onComplete]);

  if (!items.length && !title && !description) return null;

  return (
    <div
      ref={ref}
      className={`why-sme-target-reasons-block${className ? ` ${className}` : ''}`}
      id={id}
    >
      {title ? (
        <h2 className="why-sme-target-reasons-title">{title}</h2>
      ) : null}
      {description ? (
        <p className="why-sme-target-reasons-desc">{description}</p>
      ) : null}
      <div
        className="why-sme-target-reasons"
        onMouseEnter={markComplete}
      >
        {items.map((item, index) => (
          <div key={index} className="why-sme-target-reason">
            {
              item.title?(<div className="why-sme-target-reason-num reason-title">{item.title}</div>): (
                <div className="why-sme-target-reason-num">
                  {String(index + 1).padStart(2, '0')}
                </div>
              )
            }
            <p className="why-sme-target-reason-text">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
});

WhySmeTargetReasons.displayName = 'WhySmeTargetReasons';

export default React.memo(WhySmeTargetReasons);
